export enum Lottie {
  CHECK_IN = "check-in",
  SIGN_OUT = "sign-out",
  VERIFIED_EMAIL = "verified-email",
  VERIFY_EMAIL = "verify-email",
  LOADING_SPINNER = "loading-spinner",
}
